/**
 * Kimin neyi düzenleyebileceği — tek yerden.
 *
 * Sayfalar bunu kendi başlarına karar veriyordu ve çoğu yanlış karar
 * veriyordu: EventsPage "organizasyonu varsa yönetebilir" sayıyor,
 * Görevler ve Program sayfaları hiç bakmıyordu. Katılımcılar
 * kendilerini yönetici sanıyor, düzenleme düğmelerini görüyordu.
 *
 * Not: burası yalnız ARAYÜZÜ düzenler. Asıl karar sunucuda; API her
 * uçta rolü ayrıca doğruluyor. Düğmeyi gizlemek güvenlik değil,
 * kullanıcıyı yanıltmamaktır.
 */
import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import { useAuth } from './auth';
import type { Organization } from './types';

export interface Yetki {
  /** Kullanıcının bu organizasyondaki rolü. */
  rol: string;
  /** Program, görev, akış, liste kurabilir/düzenleyebilir. */
  yonetebilir: boolean;
  /** Yetki dağıtabilir, üye çıkarabilir, organizasyonu düzenleyebilir. */
  yonetici: boolean;
  yukleniyor: boolean;
  org?: Organization & { role?: string; eventAccess?: string };
}

export function useYetki(orgId?: string): Yetki {
  const { effectiveIsSuperAdmin } = useAuth();

  const { data, isLoading } = useQuery({
    queryKey: ['organizations'],
    queryFn: () => api<{ organizations: (Organization & { role?: string })[] }>('/organizations'),
  });

  const org = orgId
    ? data?.organizations.find((o) => o.id === orgId)
    : data?.organizations[0];

  const rol = effectiveIsSuperAdmin ? 'super_admin' : org?.role ?? '';
  const yonetici = rol === 'super_admin' || rol === 'org_admin';
  /* Moderatör günlük işleri yürütüyor ama yetki dağıtamıyor. */
  const yonetebilir = yonetici || rol === 'moderator';

  return { rol, yonetebilir, yonetici, yukleniyor: isLoading, org };
}
